import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Pagination } from '../models';
import { BrandInternal } from '../models/BrandInternal';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class BrandInternalService extends BaseApiService<BrandInternal> {
  get cacheKey(): StorageKey {
    return StorageKey.brandModelServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    switch (operation) {
      case 'list':
        let regionId = params.regionId;
        if (regionId == null) {
          regionId = 1;
        }
        return `${environment.apiUrl}/brandInternals`;
      default:
        let url = `${environment.apiUrl}/brandInternals`;
        if (id != null) {
          url = url + '/' + encodeURIComponent(id);
        }
        return url;
    }
  }

  protected unparse(obj) {
    return BrandInternal.unparse(obj);
  }

  protected parse(obj) {
    return BrandInternal.parse(obj);
  }

}
